export default __webpack_public_path__ + "static/media/one.fb46d41b.jpeg";